import { IconButton } from '@cad-arc';
import React from 'react';
import { useAdditionalInfos } from '../hooks/use-additional-infos/additional-infos-provider';
import { SortDirection } from '../hooks/use-additional-infos/types';

export function NarrativeSortDirectionButton(): React.JSX.Element {
    const { sortDirection, setSortDirection } = useAdditionalInfos();
    const isAsc = sortDirection === SortDirection.ASC;

    const handleToggle = React.useCallback(
        () => setSortDirection(isAsc ? SortDirection.DESC : SortDirection.ASC),
        [isAsc, setSortDirection]
    );

    return (
        <IconButton
            aria-label={isAsc ? 'Sort newest first' : 'Sort oldest first'}
            data-testid="NARRATIVE_SORT_DIRECTION_TOGGLE"
            icon="SwapVert"
            variant="ghost"
            onClick={handleToggle}
        />
    );
}
